import NormControl_TranslationDTO from './normControl_TranslationDTO';

export default class NormControlDTO {
  normId: number;

  controlId: number;

  ownerId?: string;

  ownerRoleId?: string;

  groupId?: string;

  trans?: NormControl_TranslationDTO[];

  constructor(normId?: number, controlId?: number) {
    this.normId = normId || 0;
    this.controlId = controlId || 0;
  }
}
